import AxiosInstance from '../../AxiosInstance';

const loginApibasUrl = '/login'

const LoginService = {

    Login:(details)=>{
        return AxiosInstance.post(loginApibasUrl+'/Login',details)
    },

}

export default LoginService;